import { Injectable } from '@angular/core';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Equipment } from '@polaris-customerweb/sharedcomponents.garage';
import { exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { AppState } from 'src/app/models/app-state';
import * as EquipmentActions from './equipment.actions';
import { selectUpdateEquipmentLoading } from './equipment.selectors';

@Injectable()
export class EquipmentEffects {
    readonly className = 'EquipmentEffects';

    updateEquipment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EquipmentActions.UpdateEquipment),
            map(({ equipment }) =>
                EquipmentActions.UpdateEquipmentSuccess({
                    equipment: equipment as Equipment,
                })
            )
        )
    );

    cancelUpdateEquipment = createEffect(() =>
        this.actions$.pipe(
            ofType(EquipmentActions.CancelUpdateEquipment),
            withLatestFrom(this.store.select(selectUpdateEquipmentLoading)),
            filter(([, isLoading]) => isLoading),
            exhaustMap(() => [
                EquipmentActions.UpdateEquipment({ equipment: undefined }),
            ])
        )
    );

    deleteEquipment$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EquipmentActions.DeleteEquipment),
            map(({ equipmentId }) =>
                EquipmentActions.DeleteEquipmentSuccess({ equipmentId })
            )
        )
    );

    constructor(
        private readonly actions$: Actions,
        private readonly store: Store<AppState>
    ) {}
}

export const equipmentEffectsModule = EffectsModule.forFeature([
    EquipmentEffects,
]);
